export default __webpack_public_path__ + "static/media/distanstolkning11.369730ff.png";